import { Stack } from '@mui/material';
import RpCheckbox from 'components/commons/RpCheckbox';
import useFilterStore from '../../zustandStore/useFilterStore';
import PropTypes from 'prop-types';

function CheckboxFilter(props) {
    const attrValue = useFilterStore(state => state.filters[props.comparableType][props.attrName]);
    const setFilters = useFilterStore(state => state.setFilters);
    return (
        <Stack spacing={1}>
            <RpCheckbox
                value={attrValue}
                label={props.value}
                checked={attrValue}
                onChange={(e) => setFilters(props.comparableType, { [props.attrName]: e.target.checked })}
                key={props.value}
            />
        </Stack>
    );
}

CheckboxFilter.propTypes = {
    value: PropTypes.string,
    comparableType: PropTypes.string,
    attrName: PropTypes.string,
};
export default CheckboxFilter;